<template>
  <div class="mrgbt-4 px-2 w-full">
    <div>
      <input
        :id="id"
        :checked="value"
        type="checkbox"
        :disabled="disabled"
        @change="handleChange($event.target.checked)"
      />
      <BaseLabel
        v-if="showLabel"
        :for="id"
        :info-tooltip="infoTooltip"
        :tooltip-size="tooltipSize"
      >{{ label }}</BaseLabel>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    valueType: {
      default: "boolean",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    infoTooltip: {
      type: String,
      default: "",
    },
    tooltipSize: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedName() {
      if (this.name) {
        return this.name;
      } else if (this.id) {
        return this.id;
      } else {
        return "";
      }
    },
  },
  methods: {
    handleChange(value) {
      if (this.valueType == "integer") {
        this.$emit("input", value ? 1 : 0);
      } else {
        this.$emit("input", value);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// BaseCheckbox.vue?2a1553c4